import Vue from 'vue'
import ElementUI from 'element-ui'
import VueRouter from 'vue-router'
import routes from './routes'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import locale from 'element-ui/lib/locale/lang/en'
import VueClipboard from 'vue-clipboard2'
import InfiniteLoading from 'vue-infinite-loading';

import {
  JustDigits
} from 'components/filter';

JustDigits()

Vue.use(VueRouter)
Vue.use(ElementUI, { locale })
Vue.use(VueClipboard)
Vue.use(require('vue-moment'));

import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'element-ui/lib/theme-chalk/index.css'

import { EventBus } from './event-bus.js';

console.log(EventBus);

// Routing logic
var router = new VueRouter({
	routes: routes,
	mode: 'history',
	linkActiveClass: 'open active',
	scrollBehavior: function (to, from, savedPosition) {
		return savedPosition || { x: 0, y: 0 }
	}
})

Vue.router = router

// Middleware to help us ensure the user is authenticated.
// eslint-disable-next-line no-new

Vue.use(VueAxios, axios)
Vue.use(VueAuth, {
	auth: require('./components/modules/auth/Drivers/bearer.js'),
	http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
	router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
	refreshData: {url: 'auth/refresh', method: 'GET', enabled: false, interval: 30},
	fetchData: {url: 'auth/user', method: 'GET', enabled: false},
	notFoundRedirect: {path: '/admin'},
	rolesVar: 'roles',
	// parseUserData:function(response) {
    //     return JSON.parse(localStorage.getItem('user')) //since manual fetch of user on each reload is disabled, localstorage value is used
	// }
})

Vue.use(InfiniteLoading, { /* options */ });

Vue.axios.defaults.baseURL = BASE_URL
Vue.config.productionTip = false

new Vue({
	el: '#app',
	router: router,
	store: store,
	render: h => h(App)
})

require('bootstrap')
require('admin-lte')
require('../node_modules/admin-lte/dist/js/demo.js')
require('../node_modules/admin-lte/plugins/slimScroll/jquery.slimscroll.js')

import "vue-swatches/dist/vue-swatches.min.css"

// var EventBus = new Vue()
// export default EventBus


// WEBPACK FOOTER //
// ./src/main.js